module.exports = () => {
    class Tickers {
        constructor(uuid, origin, lang, showIcon) {
            this.tickerUuid = uuid;
            this.origin = origin;
            this.lang = lang;
            this.showIcon = Boolean(showIcon);

            this.feed = null;
            this.aggregated = null;
            this.tickerData = {};
            this.icons = [];

            this.shadow = null;
            this.tickers = document.createElement("div");

            this.timeInterval = 10000;

            this.assignEvents();
        }

        async assignEvents() {
            await this.getFeed();

            if (!this.aggregated.length && !this.feed.length) {
                return;
            }

            this.appendTickers();
        }

        async getFeed() {
            const response = await fetch(
                `${this.origin}/api/tickers/${this.tickerUuid}/get-easy-cart-feed?lang=${this.lang}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            const { events, aggregated, icons, tickerData } = await response.json();

            this.aggregated = aggregated;
            this.feed = events;
            this.tickerData = tickerData;
            this.icons = icons;
        }

        appendTickers() {
            let fontLinkReady = false;
            let styleLinkReady = false;
            let momentLinkReady = false;
            let flagsLinkReady = false;

            const fontLink = document.createElement("link");
            fontLink.setAttribute("rel", "stylesheet");
            fontLink.setAttribute(
                "href",
                `https://fonts.googleapis.com/css?family=${this.tickerData.fontName.replaceAll(
                    " ",
                    "+"
                )}:300,400,500,600,700,800`
            );
            document.head.appendChild(fontLink);

            fontLink.onload = () => {
                fontLinkReady = true;
                this.whenLinksReady(
                    fontLinkReady && styleLinkReady && momentLinkReady && flagsLinkReady
                );
            };

            const flagsLink = document.createElement("style");
            flagsLink.textContent = `@import "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.0.0/css/flag-icons.min.css";`;

            const styleLink = document.createElement("style");
            styleLink.textContent = `@import "https://app.easy.tools/front/css/style.css";`;

            const shadowElem = document.createElement("div");
            shadowElem.id = "easy-ticker";
            document.body.appendChild(shadowElem);

            this.shadow = shadowElem.attachShadow({ mode: "closed" });
            this.shadow.appendChild(styleLink);
            this.shadow.appendChild(flagsLink);

            styleLink.onload = () => {
                styleLinkReady = true;
                this.whenLinksReady(
                    fontLinkReady && styleLinkReady && momentLinkReady && flagsLinkReady
                );
            };

            flagsLink.onload = () => {
                flagsLinkReady = true;
                this.whenLinksReady(
                    fontLinkReady && styleLinkReady && momentLinkReady && flagsLinkReady
                );
            };

            const momentLink = document.createElement("script");
            momentLink.src =
                "https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.30.1/moment-with-locales.min.js";
            document.head.appendChild(momentLink);

            momentLink.onload = () => {
                momentLinkReady = true;
                this.whenLinksReady(
                    fontLinkReady && styleLinkReady && momentLinkReady && flagsLinkReady
                );
            };
        }

        whenLinksReady(isReady) {
            if (!isReady) {
                return;
            }

            //append element
            const cornerYClass = this.tickerData.corner.includes("top") ? "top-0" : "bottom-0";
            const cornerXClass = this.tickerData.corner.includes("left") ? "left-0" : "right-0";
            this.tickers.classList.add(
                "transition-popup",
                "fixed",
                "transform",
                "sm:m-8",
                "sm:max-w-md",
                "sm:w-full",
                "font-normal",
                cornerXClass,
                cornerYClass
            );
            this.tickers.style.fontFamily = this.tickerData.fontName;

            this.tickers.classList.add("easy-ticker");
            this.tickers.classList.add("hide");

            this.shadow.appendChild(this.tickers);

            //show ticker
            setTimeout(() => {
                this.tickers.classList.remove("hide");
                this.appendAggregates();
            }, 100);
        }

        async appendAggregates() {
            if (!this.aggregated.length) {
                this.appendEvents();
                return;
            }

            let index = 0;

            const eventData = this.prepareAggregate(this.aggregated[index]);
            this.appendEvent(eventData);
            index++;

            const interval = setInterval(() => {
                if (index >= this.aggregated.length) {
                    clearInterval(interval);
                    this.appendEvents();
                    return;
                }
                const eventData = this.prepareAggregate(this.aggregated[index]);
                this.appendEvent(eventData);
                index++;
            }, this.timeInterval + 500);
        }

        async appendEvents() {
            if (!this.feed.length) {
                return;
            }

            let index = 0;

            const eventData = this.prepareEvent(this.feed[index]);
            this.appendEvent(eventData);
            index++;

            const interval = setInterval(() => {
                if (index >= this.feed.length) {
                    clearInterval(interval);
                    return;
                }
                const eventData = this.prepareEvent(this.feed[index]);
                this.appendEvent(eventData);
                index++;
            }, this.timeInterval + 500);
        }
        async appendEvent(eventData) {
            const eventDiv = document.createElement("div");
            eventDiv.classList.add("hide");

            const eventHtml = await this.getTickerTemplate(eventData);
            eventDiv.innerHTML = eventHtml;

            this.tickers.appendChild(eventDiv);
            setTimeout(() => {
                eventDiv.classList.remove("hide");
            }, 100);

            setTimeout(() => {
                eventDiv.classList.add("hide");
                setTimeout(() => {
                    this.tickers.removeChild(eventDiv);
                }, 300);
            }, this.timeInterval);
        }

        prepareAggregate(event) {
            const tickerEvent = this.tickerData.events.find((e) => e.code === event.type);

            const tickerText = this.replaceAggregateTextWithDynamicData(
                tickerEvent.aggregate,
                event.count,
                event.product_name
            );

            return {
                text: tickerText,
                icon: tickerEvent.image
                    ? ` <img src="${this.origin}${tickerEvent.image}" class="w-full h-full object-cover" />`
                    : this.getIcon(tickerEvent.icon),
                link: event.url,
                date: "",
            };
        }

        prepareEvent(event) {
            const tickerEvent = this.tickerData.events.find((e) => e.code === event.type);

            const tickerText = this.replaceTextWithDynamicData(tickerEvent.text, event.variables);

            return {
                text: tickerText,
                icon: tickerEvent.image
                    ? ` <img src="${this.origin}${tickerEvent.image}" class="w-full h-full object-cover" />`
                    : this.getIcon(tickerEvent.icon),
                link: event.url,
                date: window.moment(event.date).locale(this.lang).fromNow(),
            };
        }

        replaceAggregateTextWithDynamicData(text, count, product_name) {
            text = text.replace(`{count}`, count);
            text = text.replace(`{product_name}`, product_name);

            return text;
        }

        replaceTextWithDynamicData(text, data) {
            const fields = ["product_name", "price", "customer_name", "city"];
            fields.forEach((field) => {
                if (text.includes(`{${field}}`)) {
                    text = text.replace(`{${field}}`, data[field] || "");
                }
                if (text.includes("{country_code}")) {
                    text = text.replace(
                        "{country_code}",
                        `<span class="inline-block fi fi-${data["country_code"].toLowerCase()}"></span>`
                    );
                }
            });
            return text;
        }

        async getTickerTemplate(event) {
            return `<a href="${this.tickerData.link || event.link}" class="flex items-center space-x-2.5 sm:rounded-lg px-3.5 py-2.5 text-left overflow-hidden shadow-sm border sm:max-w-md sm:w-full mb-2 transform transition-ticker" style="background-color: ${this.tickerData.colors.background}; border-color: ${this.tickerData.colors.border};">

                    ${
                        this.showIcon
                            ? `<div class="flex-shrink-0 relative flex items-center justify-center h-10 w-10 rounded-lg overflow-hidden border" style="color: ${this.tickerData.colors.cardText}; border-color: ${this.tickerData.colors.border}; background-color: ${this.tickerData.colors.cardBackground};">${event.icon}</div>`
                            : ""
                    }
             

                    <div>
                        <p class="text-base font-medium" style="color: ${this.tickerData.colors.text};">
                            ${event.text}
                        </p>
                        <div class="mt-0.5 text-sm font-regular opacity-80">
                            <p style="color: ${this.tickerData.colors.text}"
                            >
                                ${event.date} ${event.date ? "|" : ""} ${this.lang === "en" ? "verified by" : "zweryfikowane przez"} ${this.getIcon("StripeLogoIcon")}
                            </p>
                        </div>
                    </div>
                 </a>`;
        }

        getIcon(icon) {
            return this.icons.find((i) => i.name === icon).code;
        }
    }

    function startEasyticker() {
        new Tickers("uuidToReplace", "originToReplace", "langToReplace", "showIconToReplace");
    }

    if (document.readyState !== "loading") {
        startEasyticker();
    } else {
        document.addEventListener("DOMContentLoaded", startEasyticker);
    }
};
